<template>
  <div
    class="px-16 py-8 flex justify-center h-full items-center border-b border-b-neutral-100/10"
  >
    <OSelect
      v-if="!livre"
      v-model="model"
      :options="options"
      size="md"
      :class="{
        'opacity-60 pointer-events-none': !itemopcao.pode_responder,
        invisible: !itemopcao.pode_ver,
      }"
      class="text-headline-3 w-full OButtonAlternativa transition-colors h-48 !border-neutral-100/10 bg-white !border-0 !mb-0"
      @update:modelValue="
        (v) => $emit('update:opt', { value: v.value })
      "
    >
      <template #selected>
        <q-item class="items-center gap-8 !px-4">
          <q-icon
            size="1.5rem"
            :style="{ color: model.color }"
            :name="model.icon"
          />
          <p>{{ model.label }}</p>
        </q-item>
      </template>
      <template #option="scope">
        <q-item v-bind="scope.itemProps">
          <q-item-section avatar>
            <q-icon
              :style="{ color: scope.opt.color }"
              :name="scope.opt.icon"
            />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ scope.opt.label }}</q-item-label>
            <q-item-label caption>
              {{ scope.opt.description }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </OSelect>
    <OInput
      v-else
      v-model="modelLivre"
      primary
      size="md"
      class="w-full"
      :type="fieldType.type"
      :mask="fieldType.mask"
      :reverse-fill-mask="fieldType.reverseFillMask"
      :placeholder="fieldType.placeholder || '0'"
      :class="{
        'opacity-60 pointer-events-none': !itemopcao.pode_responder,
        invisible: !itemopcao.pode_ver,
      }"
      @change="
        (v) =>
          $emit('update:opt', {
            livre: { value: v, tipo: itemopcao.tipo_resposta_livre },
          })
      "
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { tipoCampoLivre } from 'js/utils/constants/pergunta'
import OInput from 'components/Input/OInput.vue'
import OSelect from 'components/Select/OSelect.vue'

const props = defineProps({
  label: String,
  itemopcao: Object,
  colorActive: String,
})

const model = ref({
  label: 'Vazio',
  value: '',
  icon: 'horizontal_rule',
  color: '#171719',
})

const modelLivre = ref('')

const options = [
  { label: 'Sim', value: 'sim', icon: 'check', color: '#0aa335' },
  { label: 'Não', value: 'nao', icon: 'close', color: '#e92c2c' },
  {
    label: 'Vazio',
    value: '',
    icon: 'horizontal_rule',
    color: '#171719',
  },
]

watch(
  () => props.itemopcao?.item_resposta?.resposta_select,
  (v) => {
    const opt = options.find((opt) => opt.value === v || null)
    if (!opt) return
    model.value = opt
  },
  {
    immediate: true,
  }
)

watch(
  () => props.itemopcao?.item_resposta?.resposta_livre,
  (v) => {
    if (!v) return
    modelLivre.value = v
  },
  {
    immediate: true,
  }
)

const fieldType = computed(() => {
  const tipo = tipoCampoLivre(props.itemopcao.tipo_resposta_livre)

  if (tipo.livre) return { type: 'text', placeholder: '-' }
  if (tipo.data_hora) return { type: 'time', placeholder: 'HH:mm' }
  if (tipo.porcentagem)
    return { type: 'text', mask: '##,##%', reverseFillMask: true }

  return { type: 'number' }
})

const livre = computed(() => props.itemopcao.tipo === 'livre')
const emit = defineEmits(['update:opt'])
</script>

<style lang="scss" scoped></style>
